import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.jobPageStore.jobAuthz['create'])
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: $setup.jobPageStore.createJobHref(),
        class: _normalizeClass(["btn", `btn-${$props.btnType}`])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-plus" }, null, -1)),
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t("new.job.button.label")), 1)
        ])
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}